module.exports = __webpack_public_path__ + "static/img/pMRI_last.946d9a2d.png";